const colors = {
  //genericColors ( used both as background or text )
  primary: '#243487',
  secondary: '#243487',
  white: '#FFFFFF',
  //backgrounds
  bgPrimary: '#243487',
  bgSecondary: '#305B5B',
  pageBg: '#f7f7f7',
  footerIconBg: '#DEA859',
  //text
  textPrimary: '#2F3C43',
  textSecondary: '#FFFFFF',
  textThertiary: '##2F3C43',
  smokyBlack: '#222222',
  //FORM COMPONENTS
  fieldColor: '#969DA0',
  fieldFocusColor: '#243487',
  fieldDisabledColor: '#969da0',
  alertFieldColor: '#DE8559',
  errorFieldColor: '#CB4249',
  checkboxBorder: '#D5D8D9',
  selectOptionActiveColor: '#E4E6F0',
  selectedPromotion: 'linear-gradient(90deg, #FFED3B 0%, #B9A345 100%)',
  promoText: '#243487',
  //loader
  loaderOverlayBg: 'rgba(255, 255, 255, 0.95)',
  //buttons
  primaryButtonBg: 'linear-gradient(45deg, #243487 0%, #7680B4 100%);',
  primaryButtonColor: '#FFFFFF',
  secondaryButtonBg: '#DEA859',
  thertiaryButtonBg: 'transparent',
  outlinedButtonColor: '#243487',
  //modal
  modalHeaderBg: '#243487',
};

export type ColorKeys = keyof typeof colors;

export default colors;
